import { addresses } from '../address'
import { describeTable } from './describeTable'

describeTable(addresses, {
  description: `A postal address with geocoded coordinates, referenced by properties.address_id (where work happens) and customers.address_id (an organisation's own office). Not shared between rows in practice — one address row per property. Coordinates come from Google geocoding at creation and are the input for route planning and area / region analysis; postal_code and city are the practical grouping keys (city is free text as the customer typed it, so normalise case before grouping).`,
  columns: {
    street: 'Street address including house number.',
    postalCode: 'Finnish 5-digit postal code; NULL on some legacy rows.',
    country:
      "Usually NULL or 'Finland'; effectively all addresses are Finnish.",
    latitude:
      'WGS84 latitude stored as a decimal string; NULL if geocoding failed.',
    longitude: 'WGS84 longitude stored as a decimal string.',
    streetViewCameraLat:
      'Google Street View camera position used for the technician preview image; operational only.',
    streetViewCameraLng: 'See street_view_camera_lat.',
    streetViewHeading: 'Camera heading in degrees for the Street View preview.',
  },
})
